export default __webpack_public_path__ + "static/media/kitchen5-beforeA-1024w.3a225bd0.png";